// extracted by mini-css-extract-plugin
export default {"cls1":"qvEUahzaUakUdhAI15Q2","cls2":"mu2udIaygKWtTt9j6BGi qvEUahzaUakUdhAI15Q2","selected":"d4Ex7enERz_rJUQoZWZW"};